<template>
  <div class="vsm-filter-chips" :class="'vsm-filter-chips--' + size">
    <span
      class="vsm-chip vsm-chip-clickable total"
      :class="{ 'vsm-chip-selected': totalSelected }"
      @click="$emit('clear-filters')"
    >{{ totalLabel }}</span>
    <slot />
    <slot name="extras" />
    <b-form-input
      v-if="showSearch"
      class="vsm-filter-search"
      :value="searchFilter"
      @input="$emit('update:searchFilter', $event)"
      :placeholder="searchPlaceholder"
    />
    <span v-if="$slots.actions" class="vsm-filter-actions">
      <slot name="actions" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'vsm-mobile-filter-chips',

  props: {
    itemsCount: { type: Number, default: 0 },
    totalCount: { type: Number, default: 0 },
    totalSelected: { type: Boolean, default: false },
    totalFormat: { type: String, default: 'slash' },
    showSearch: { type: Boolean, default: true },
    searchFilter: { type: String, default: '' },
    searchPlaceholder: { type: String, default: 'filter by keyword' },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
  },

  computed: {
    totalLabel() {
      if (this.totalFormat === 'of') {
        return `${this.itemsCount} of ${this.totalCount}`
      }
      return `${this.itemsCount}/${this.totalCount}`
    },
  },
}
</script>

<!-- unscoped: the chips arrive through slots, which carry the parent's scope
     attribute, so scoped child selectors here would never match them -->
<style>
/* one-row strip at every width: nowrap + horizontal scroll (the vsm_board
   swipe pattern). touch gets a hidden scrollbar with a right fade and a
   trailing spacer; mouse/wheel devices get a slim visible scrollbar instead,
   since a hidden bar strands them. */
/* doubled class outranks vsm-mobile.css's base .vsm-filter-chips rules
   regardless of bundle order */
.vsm-filter-chips.vsm-filter-chips {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 4px 6px;
  /* the scrollport clips the selected chip's 2px outline (drawn outside the
     box); inner padding keeps it visible on the flush first/last chips */
  padding: 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  mask-image: linear-gradient(to right, #000 calc(100% - 22px), transparent);
}
.vsm-filter-chips.vsm-filter-chips::-webkit-scrollbar {
  display: none;
}
.vsm-filter-chips.vsm-filter-chips::after {
  content: '';
  flex: 0 0 28px;
}
.vsm-filter-chips.vsm-filter-chips > * {
  flex: 0 0 auto;
}
@media (max-width: 640px) {
  .vsm-filter-chips .vsm-filter-search {
    /* iOS focus-zoom dodge; fixed width so it shares the strip */
    font-size: 16px;
    width: 140px;
  }
}
@media (hover: hover) and (pointer: fine) {
  .vsm-filter-chips.vsm-filter-chips {
    scrollbar-width: thin;
    mask-image: none;
  }
  .vsm-filter-chips.vsm-filter-chips::-webkit-scrollbar {
    display: block;
    height: 6px;
  }
  .vsm-filter-chips.vsm-filter-chips::-webkit-scrollbar-thumb {
    background: #c2cad3;
    border-radius: 3px;
  }
  .vsm-filter-chips.vsm-filter-chips::after {
    content: none;
  }
}
</style>
